import { useMemo, useState } from "react";
import type { NewsArticle } from "@/mocks/news";
import NewsCard from "@/components/feature/NewsCard";

const sortOptions = [
  { key: "latest", label: "最新优先" },
  { key: "hot", label: "热度优先" },
] as const;

type SortKey = (typeof sortOptions)[number]["key"];

export default function CategoryList({ items }: { items: NewsArticle[] }) {
  const [sort, setSort] = useState<SortKey>("latest");

  const sorted = useMemo(() => {
    const copy = [...items];
    if (sort === "hot") return copy.sort((a, b) => b.hot - a.hot);
    return copy.sort((a, b) => (a.publishedAt < b.publishedAt ? 1 : -1));
  }, [items, sort]);

  const [lead, ...rest] = sorted;

  return (
    <div>
      <div className="mb-5 flex flex-wrap items-center justify-between gap-3">
        <p className="text-sm text-foreground-600">
          共 <span className="font-medium text-foreground-900">{items.length}</span> 条内容
        </p>
        <div className="flex items-center gap-1 rounded-full border border-background-300 bg-background-100 p-1">
          {sortOptions.map((option) => (
            <button
              key={option.key}
              type="button"
              onClick={() => setSort(option.key)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-1.5 text-sm transition ${
                sort === option.key
                  ? "bg-foreground-950 text-background-50"
                  : "text-foreground-600 hover:text-primary-600"
              }`}
            >
              {option.label}
            </button>
          ))}
        </div>
      </div>

      {lead && (
        <div className="mb-6">
          <NewsCard article={lead} variant="wide" />
        </div>
      )}

      <div className="rounded-lg border border-background-200 bg-background-50 px-5 py-2">
        {rest.map((item) => (
          <NewsCard key={item.id} article={item} variant="row" />
        ))}
        {rest.length === 0 && (
          <p className="py-10 text-center text-sm text-foreground-500">
            该栏目目前只有一条内容，更多速递正在路上。
          </p>
        )}
      </div>
    </div>
  );
}